import { useEffect } from 'react';

import useBranchId from '@maya/hooks/useBranchId';
import useTranslate from '@maya/hooks/useTranslate';
import { useAppDispatch, useAppSelector } from '@maya/store/hooks';
import { loadSummary, selectVisitsSummary } from '@maya/store/slices/visit';

export default function useSummary() {
  const branchId = useBranchId();
  const t = useTranslate();

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!branchId) {
      return;
    }

    dispatch(loadSummary(branchId, t));
  }, [branchId, dispatch, t]);

  return useAppSelector(selectVisitsSummary);
}
